import {
  find,
  forEach,
  get,
  intersection,
  isEmpty,
  isNil,
  keys,
  map,
  size,
  some,
  values,
} from 'lodash'

import { mergeArrayOfObjects } from '../../core/utils'

import { INGREDIENT_KEYWORD_TYPES } from '../../common/constants'
import { buildIngredientKeywordTree } from '../../common/helpers'
import { flattenTreeStructure } from '../../common/utils'

import transformListToTree from './transform-list-to-tree'

const deleteKeywordsInKeys = (keywordFlatList, keysToDelete) => {
  const keywordsToKeepMap = {}

  forEach(keywordFlatList, node => {
    const shouldDeleteNode = some(keysToDelete, key => key === node.key)

    if (!shouldDeleteNode) {
      keywordsToKeepMap[node.id] = node
      return
    }

    if (node.parentId === null) {
      keywordsToKeepMap[node.id] = node
      return
    }

    if (node.isName) {
      throw new Error("Can't delete the name of the ingredient")
    }

    const areAllChildrenToBeDeleted =
      isEmpty(node?.children) ||
      size(intersection(keysToDelete, map(node?.children, 'key'))) ===
        size(node?.children)

    if (!areAllChildrenToBeDeleted) {
      throw new Error(
        `Can't delete keyword: ${node.term}. It doesn't have all it's children deleted as well`,
      )
    }

    const isParentDeleted = isNil(get(keywordsToKeepMap, node.id))

    if (node?.isSubtype && !isParentDeleted) {
      keywordsToKeepMap[node.id] = node
    }
  })

  return values(keywordsToKeepMap)
}

const deleteByCheckedKeywordKeysOnKeywordTrees = keywordsState =>
  mergeArrayOfObjects(
    map(keys(keywordsState.data), keywordType => {
      const keywordsWithoutDeletedNodes = deleteKeywordsInKeys(
        flattenTreeStructure(get(keywordsState.data, keywordType)),
        get(keywordsState.checkedKeywordKeys, keywordType),
      )

      const keywordTree = transformListToTree(keywordsWithoutDeletedNodes)

      return {
        [keywordType]: buildIngredientKeywordTree({
          keywordTree,
          keywordType: find(
            values(INGREDIENT_KEYWORD_TYPES),
            ({ field }) => field === keywordType,
          ),
          skipCategoryCreation: true,
        }),
      }
    }),
  )

export default deleteByCheckedKeywordKeysOnKeywordTrees
